export const name = 'multilingual' as const
export const MultilingualSymbol = Symbol.for('Multilingual')
export const MultilingualSetCurrentLanguageSymbol = Symbol.for('MultilingualSetCurrentLanguage')
export const MultilingualLinkUtilsAPISymbol = Symbol('MultilingualLinkUtilsAPI')
